import { isBrowser } from "./browser";
import Cookies from "./cookies";

const cookieKey = "external_job_ids_list";

/**
 * Retrieve and decode the job object from the cookie.
 */
const getJobObject = () => {
    const cookie = Cookies.get(cookieKey);
    const decodedData = window.atob(cookie.toString());
    const jobObject = JSON.parse(decodedData || "{}");
    return jobObject;
};

/**
 * Inject a new job ID and dedupe the list.
 */
const updateJobList = (list: number[], id: number) => {
    list.push(id);
    const newList = list.filter((x: number, index: number) => list.indexOf(x) === index);
    return newList;
};

/**
 * Creat or update the jobs object.
 */
const setJobObject = (companyId: string, jobId: number) => {
    const jobObject = getJobObject();
    jobObject[companyId] = jobObject[companyId]
        ? updateJobList(jobObject[companyId], jobId)
        : [jobId];
    const encryptedJobs = window.btoa(JSON.stringify(jobObject));
    return encryptedJobs;
};

/**
 * Sets a cookie with the encrypted companies and jobs applied to by this session within the last 30 days.
 */
const externalJobApply = (companyId: string, jobId: number) => {
    if (!isBrowser()) {
        return;
    }
    const jobObject = setJobObject(companyId, jobId);
    Cookies.set(cookieKey, jobObject, 30);
};

export {
    cookieKey,
    externalJobApply
};
